// extracted by mini-css-extract-plugin
export default {"form":"SigninForm_form__J1dsX","icons":"SigninForm_icons__i9X6-","forgotPassword":"SigninForm_forgotPassword__H9QJy"};